import type { Ref } from '@wix/thunderbolt-types'
import { createDataNode, createDataRef } from '../nodeFactory/dataNodeUtils'
import { removeHash } from '../refs/removeHash'
import type { GlobalStyleDataItem } from '../types/GlobalStyleDataItem.types'

export const GlobalStyle = createDataNode<
	GlobalStyleDataItem,
	{
		referencedStyle?: Ref<GlobalStyleDataItem>
	}
>({
	getDependencies: (dataItem: GlobalStyleDataItem) => {
		if (typeof dataItem?.value === 'string') {
			return {
				referencedStyle: createDataRef('data', 'theme_data', removeHash(dataItem.value))
			}
		}
		return {}
	},
	toViewItem: (dataItem: GlobalStyleDataItem, _: null, { referencedStyle }) => {
		return referencedStyle || dataItem
	},
})
